import React, { useState } from "react";
import { BookOpen, ChevronLeft, ChevronRight, X } from "lucide-react";

export default function PeekInside({ pages = [], title }) {
  const [open, setOpen] = useState(false);
  const [i, setI] = useState(0);
  const [dir, setDir] = useState(1);
  if (!pages.length) return null;
  const go = (n) => { setDir(n > i ? 1 : -1); setI(Math.min(pages.length - 1, Math.max(0, n))); };

  return (
    <>
      <button onClick={() => { setI(0); setOpen(true); }} data-testid="peek-inside-btn"
        className="mt-4 w-full inline-flex items-center justify-center gap-2 rounded-full border-2 border-[#FFD93D] bg-[#FFD93D]/20 hover:bg-[#FFD93D]/40 px-5 py-3 font-display font-bold text-[#19324A] transition-colors">
        <BookOpen className="w-5 h-5" /> Peek Inside the Book
        <span className="text-xs font-semibold text-[#19324A]/60">· {pages.length} pages</span>
      </button>

      {open && (
        <div className="fixed inset-0 z-[70] bg-[#19324A]/80 backdrop-blur-sm flex items-center justify-center p-3 sm:p-6" data-testid="peek-inside-modal" onClick={() => setOpen(false)}>
          <div className="relative w-full max-w-3xl" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between text-white mb-3 px-1">
              <p className="font-display font-bold text-sm sm:text-base flex items-center gap-2"><BookOpen className="w-4 h-4 text-[#FFD93D]" /> {title} — a little peek</p>
              <button onClick={() => setOpen(false)} aria-label="Close" data-testid="peek-close" className="w-9 h-9 rounded-full bg-white/15 hover:bg-white/30 flex items-center justify-center"><X className="w-5 h-5" /></button>
            </div>
            <div className="relative rounded-3xl overflow-hidden bg-[#FFF9EE] soft-shadow" style={{ perspective: "1600px" }}>
              <img key={i} src={pages[i]} alt={`${title} page ${i + 1}`} data-testid="peek-page-img"
                className="w-full max-h-[72vh] object-contain bg-[#FFF9EE]"
                style={{ animation: `peek-flip-${dir > 0 ? "in" : "back"} .55s cubic-bezier(.2,.8,.2,1)`, transformOrigin: dir > 0 ? "left center" : "right center" }} />
              <button onClick={() => go(i - 1)} disabled={i === 0} aria-label="Previous page" data-testid="peek-prev"
                className="absolute left-2 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white soft-shadow flex items-center justify-center disabled:opacity-30 hover:scale-105 transition-transform"><ChevronLeft className="w-6 h-6 text-[#19324A]" /></button>
              <button onClick={() => go(i + 1)} disabled={i === pages.length - 1} aria-label="Next page" data-testid="peek-next"
                className="absolute right-2 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white soft-shadow flex items-center justify-center disabled:opacity-30 hover:scale-105 transition-transform"><ChevronRight className="w-6 h-6 text-[#19324A]" /></button>
            </div>
            <div className="flex items-center justify-center gap-2 mt-4">
              {pages.map((_, k) => (
                <button key={k} onClick={() => go(k)} aria-label={`Page ${k + 1}`} className={`h-2.5 rounded-full transition-all ${k === i ? "w-8 bg-[#FFD93D]" : "w-2.5 bg-white/40 hover:bg-white/70"}`} />
              ))}
              <span className="ml-3 text-white/80 text-xs font-display font-semibold" data-testid="peek-counter">{i + 1} / {pages.length}</span>
            </div>
          </div>
          <style>{`
            @keyframes peek-flip-in { from { transform: rotateY(-70deg); opacity: .2 } to { transform: rotateY(0); opacity: 1 } }
            @keyframes peek-flip-back { from { transform: rotateY(70deg); opacity: .2 } to { transform: rotateY(0); opacity: 1 } }
          `}</style>
        </div>
      )}
    </>
  );
}
